import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import { POLICIES } from "../data/site";

export default function Policies() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-[#0A0A0A] text-white pt-28 pb-24">
      <section className="relative py-16 lg:py-24 overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-50" />
        <div className="absolute -top-24 right-0 h-[400px] w-[420px] rounded-full bg-[#F5D67B]/10 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-11 w-11 rounded-xl bg-gradient-brand-soft border border-white/10 flex items-center justify-center">
              <ShieldCheck className="h-5 w-5 text-[#D4AF37]" />
            </div>
            <p className="text-sm font-semibold tracking-[0.25em] uppercase text-[#D4AF37]">Company Policies</p>
          </div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.05] max-w-4xl">
            Clear, transparent and{" "}
            <span className="text-gradient-brand">on your side.</span>
          </h1>
          <p className="mt-6 text-lg text-gray-300 max-w-2xl">
            We keep our terms simple so you can focus on your business. Here's exactly how we work.
          </p>
        </div>
      </section>

      <section className="py-10">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 grid md:grid-cols-2 gap-5">
          {POLICIES.map((p, i) => (
            <div
              key={i}
              data-testid={`policies-page-card-${i}`}
              className="rounded-2xl border border-white/10 bg-[#121212] p-8 hover:border-[#D4AF37]/35 transition"
            >
              <div className="flex items-center gap-3 mb-5">
                <span className="font-display text-xs font-bold text-[#D4AF37] tracking-widest">0{i + 1}</span>
                <div className="h-px flex-1 bg-gradient-to-r from-[#D4AF37]/40 to-transparent" />
              </div>
              <h2 className="font-display text-2xl font-bold mb-5">{p.title}</h2>
              <ul className="space-y-3">
                {p.points.map((pt, j) => (
                  <li key={j} className="flex items-start gap-3 text-gray-300">
                    <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#D4AF37] shrink-0" />
                    <span className="text-sm md:text-base">{pt}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-16">
        <div className="max-w-4xl mx-auto px-5 lg:px-8">
          <div className="rounded-3xl bg-gradient-brand p-10 md:p-12 text-center glow-blue">
            <h3 className="font-display text-3xl md:text-4xl font-bold text-[#0A0A0A] mb-3">
              Any questions about our terms?
            </h3>
            <p className="text-black/70 mb-7 max-w-2xl mx-auto">
              We're happy to walk you through everything before you decide.
            </p>
            <Link to="/contact" data-testid="policies-cta-button">
              <Button className="bg-white text-[#0A0A0A] hover:bg-[#F5D67B]/20 rounded-full h-12 px-7 font-bold">
                Contact Us <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
